const options = {
  tenant: process.env.VUE_APP_TENANT,
  origin: process.env.VUE_APP_ORIGIN,
  autoheight: true,
  debug: true,
};

const i18n = {
  "hu": require("./i18n/hu-HU.js").default,
  "en": require("./i18n/en-GB.js").default
}

const language = {
  locale: "hu",
  messages: {
    "hu": i18n.hu.messages,
    "en": i18n.en.messages,
  },
  numberFormats: {
    "hu": i18n.hu.numberFormats,
    "en": i18n.en.numberFormats,
  },
  datetimeFormats: {
    "hu": i18n.hu.datetimeFormats,
    "en": i18n.en.datetimeFormats,
  }
}

export { language, options };